import React from 'react';

const Loader = ({ show }) => {
  /* Previous loader (spinner + inline container) — kept for reference
  const loaderContainerStyle = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backdropFilter: 'blur(1px)',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: '9998',
    pointerEvents: 'none',
  };

  const spinnerStyle = `
  .loader {
    width: 50px;
    aspect-ratio: 1;
    display: grid;
    -webkit-mask: conic-gradient(from 15deg, #21cdc0, #0000);
    animation: l26 1s infinite steps(12);
  }
  .loader,
  .loader:before,
  .loader:after {
    background:
      radial-gradient(closest-side at 50% 12.5%, #21cdc0 96%, #0000) 50% 0/20% 80% repeat-y,
      radial-gradient(closest-side at 12.5% 50%, #21cdc0 96%, #0000) 0 50%/80% 20% repeat-x;
  }
  .loader:before,
  .loader:after {
    content: "";
    grid-area: 1/1;
    transform: rotate(30deg);
  }
  .loader:after {
    transform: rotate(60deg);
  }

  @keyframes l26 {
    100% { transform: rotate(1turn) }
  }
`;

  return show && (
    <div>
      <style>{spinnerStyle}</style>
      <div style={loaderContainerStyle}>

        <div className="loader"></div>
      </div>
    </div>
  );
  */

  const loaderOverlayStyles = `
    .hlthtek-admin-demo-loader .wi-loader-overlay {
      position: fixed;
      inset: 0;
      z-index: 9998;
      background: rgba(255, 255, 255, 0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 16px;
    }
    .hlthtek-admin-demo-loader .wi-favicon-spin {
      width: 48px;
      height: 48px;
      animation: hlthtek-admin-demo-wi-spin 0.9s linear infinite;
    }
    @keyframes hlthtek-admin-demo-wi-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `;

  return (
    show && (
      <div className="hlthtek-admin-demo-loader">
        <style>{loaderOverlayStyles}</style>
        <div className="wi-loader-overlay" aria-busy="true" aria-live="polite">
          <img
            className="wi-favicon-spin"
            src={`${process.env.PUBLIC_URL || ''}/favicon.ico`}
            alt=""
          />
          <span style={{ color: '#546e7a', fontSize: '0.95rem' }}>Loading...</span>
        </div>
      </div>
    )
  );
};

export default Loader;
